import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'app-new-folder-dialog',
  templateUrl: './new-folder-dialog.component.html',
  styleUrls: ['./new-folder-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    TranslocoPipe
  ],
  providers: [TranslocoPipe]
})
export class NewFolderDialogComponent {
  fileName: string;
  fileUrl: string;
  provider: string;
  fileType: string;
  fileTypes: string[] = ['IMMAGINE', 'PDF', 'VIDEO', 'AUDIO', 'WORD', 'EXCEL', 'POWERPOINT'];
  providers: string[] = ['INTERNAL', 'VIMEO', 'YOUTUBE', 'GOOGLE DRIVE', 'ONEDRIVE', 'SHAREPOINT'];

  constructor(
    public dialogRef: MatDialogRef<NewFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.fileName = this.data.fileName;
    this.fileUrl = this.data.fileUrl;
    this.provider = this.data.provider;
    this.fileType = this.data.fileType;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onExternalUploadClick(): void {
    const payload = {
      fileName: this.data.fileName,
      fileUrl: this.data.fileUrl,
      provider: this.data.provider,
      fileType: this.data.fileType,
      shareLevel: 'PUB',  
      action: 'externalUpload'
    };
    this.dialogRef.close(payload);
  }

  onCreateClick(): void {
    if (this.data.action === 'externalUpload') {
      this.onExternalUploadClick();
    } else if (this.data.folderName.trim().length > 0) {
      this.data.errorMessage = '';  // Resetta il messaggio di errore
      this.dialogRef.close({ folderName: this.data.folderName, action: this.data.action });
    } else {
      this.data.errorMessage = "Il nome della cartella non può essere vuoto";
    }
  }
}
